/** Use the host's ordinary, refreshable session; store no additional credential. */
export function accountControls(root,cloud,app,{getAccessToken}){
  const controls=document.createElement('div');controls.className='development-approval';root.querySelector('form .submit').before(controls);
  const link=root.querySelector('[data-account-link]');
  let identity=null,version=0,disposed=false;
  function clear(){version++;identity=null;controls.replaceChildren();root.querySelector('[data-anonymous-choice]').hidden=true;link.textContent='Ärenden och svar i Vibe Cloud ↗';link.href=`${cloud}/support?app=${encodeURIComponent(app)}`;}
  async function read(){
    const token=await getAccessToken();if(!token)return null;
    const response=await fetch(`${cloud}/api/development/widget`,{headers:{Authorization:`Bearer ${token}`},credentials:'omit',referrerPolicy:'no-referrer',signal:AbortSignal.timeout(10000)});
    if(!response.ok)throw new Error('Kontots feedbackbehörighet kunde inte verifieras. Logga in igen.');
    return {token,data:await response.json()};
  }
  async function refresh(){
    const seq=version,result=await read();if(disposed||version!==seq)return null;
    if(!result){clear();return null;}identity=result.data.did;
    const data=result.data;root.querySelector('[data-anonymous-choice]').hidden=false;
    link.textContent=data.canImplement?'Mina uppdrag ↗':'Mina ärenden ↗';link.href=`${cloud}/support?app=${encodeURIComponent(app)}${data.canImplement?'&admin=1':''}`;
    if(data.canImplement)controls.innerHTML=`<label class="approval-choice"><input type="checkbox" name="implement"><span><strong>${data.canPublish?'Godkänn implementation och publicering':'Godkänn implementation'}</strong></span></label>`;
    else controls.replaceChildren();
    return data;
  }
  clear();
  return {refresh,async authorization(){
    const seq=version,expected=identity,result=await read();
    if(disposed||seq!==version||!expected||!result||result.data.did!==expected)throw new Error('Kontot har ändrats eller loggats ut. Öppna formuläret igen.');
    const approved=root.querySelector('[name=implement]')?.checked;
    if(approved&&!result.data.canImplement)throw new Error('Du har inte längre rätt att godkänna ändringar.');
    return `Bearer ${result.token}`;
  },clear,destroy(){disposed=true;clear();}};
}
